export const USER_ENDPOINTS = {
  USERS: '/api/v1/users',
};

// unique query keys for each API
export enum UserEndpointQueryKeys {
  GET_USERS = 'get-users',
  GET_SPECIFIC_USER = 'get-specific-user',
  EDIT_USER = 'edit-user',
  DELETE_USER = 'delete-user',
  CREATE_USER = 'create-user',
}
